import { initializeApp, getApps } from "firebase/app";
import { getDatabase, ref, push, set } from "firebase/database";
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";

const cfg = {
  apiKey: "AIzaSyA_wrfbELaJlk9oOz2YqgpuqrKBg16CgKU",
  authDomain: "amarisweb.firebaseapp.com",
  databaseURL:
    "https://amarisweb-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "amarisweb",
  storageBucket: "amarisweb.firebasestorage.app",
  messagingSenderId: "587520755187",
  appId: "1:587520755187:web:639f2c76dab3372b2d3e86",
};

const app = getApps().length ? getApps()[0] : initializeApp(cfg);
const db = getDatabase(app);
const storage = getStorage(app);

export async function uploadCV(file, applicationId) {
  const path = `cvs/${applicationId}/${Date.now()}_${file.name}`;
  const fileRef = storageRef(storage, path);
  await uploadBytes(fileRef, file);
  const url = await getDownloadURL(fileRef);
  return { url, path };
}

export async function pushToFirebase(data) {
  await set(push(ref(db, "applications")), data);
}